export default function MySQL_TRUNCATE() {
  return (
    <div>
      <h2>MySQL_TRUNCATE</h2>    </div>
  );
}